<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-dialog modal-lg modal-dialog-centered" (click)="$event.stopPropagation()">
    <div class="modal-content shadow-lg border-0">

      <div class="modal-header bg-light">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-person-badge me-2"></i> Selecionar Funcionário
        </h5>
        <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <div class="input-group mb-4 shadow-sm">
          <span class="input-group-text bg-white border-end-0">
            <i class="bi bi-search text-muted"></i>
          </span>
          <input
            type="text"
            class="form-control border-start-0"
            placeholder="Pesquisar por nome ou cargo..."
            [(ngModel)]="busca"
            (input)="filtrar()"
          />
        </div>

        <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
          <table class="table table-hover align-middle">
            <thead class="table-light sticky-top">
              <tr>
                <th class="text-center" style="width: 50px;">#</th>
                <th>Nome</th>
                <th>Cargo</th>
                <th>Setor</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let f of funcionariosFiltrados"
                (click)="selecionar(f)"
                [class.table-primary]="selecionado && resolverIdFuncionario(selecionado) === resolverIdFuncionario(f)"
                style="cursor: pointer;"
              >
                <td class="text-center">
                  <div class="form-check d-flex justify-content-center">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="funcionario"
                      [checked]="selecionado && resolverIdFuncionario(selecionado) === resolverIdFuncionario(f)"
                      (click)="$event.stopPropagation()"
                    />
                  </div>
                </td>
                <td><div class="fw-bold text-dark">{{ f.nome }}</div></td>
                <td><span class="text-secondary">{{ f.cargo }}</span></td>
                <td><span class="text-muted small">{{ f.setor }}</span></td>
              </tr>
              <tr *ngIf="funcionariosFiltrados.length === 0">
                <td colspan="4" class="text-center py-5">
                  <i class="bi bi-person-exclamation fs-2 text-muted d-block mb-2"></i>
                  <span class="text-muted">Nenhum funcionário encontrado.</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancelar</button>
        <button
          type="button"
          class="btn btn-success px-5"
          [disabled]="!selecionado"
          (click)="confirmar()"
        >
          <i class="bi bi-check-lg me-2"></i> Confirmar Seleção
        </button>
      </div>

    </div>
  </div>
</div>
